import React from "react";

const VARIANTS = {
    uploaded: {
        pill: "bg-green-500/10 text-green-700",
        dot: "bg-green-600",
    },
    required: {
        pill: "bg-red-500/10 text-red-700",
        dot: "bg-red-500",
    },
    optional: {
        pill: "bg-tm-gray-100 text-tm-gray-600",
        dot: "bg-tm-gray-400",
    },
};

export default function DocBadge({label, status = "required", onClick}) {
    const {pill, dot} = VARIANTS[status] ?? VARIANTS.required;

    const Tag = onClick ? "button" : "span";

    return (
        <Tag
            type={onClick ? "button" : undefined}
            onClick={onClick}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${pill}${onClick ? " cursor-pointer hover:opacity-80 transition-opacity" : ""}`}
        >
            <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${dot}`} />

            {label}
        </Tag>
    );
}
